var app = angular.module("leonardo");

var UserRolesListFilters = function(
  $scope,
  $controller,
  AccountUserService,
) {

  $controller('FiltersBaseController', { $scope: $scope });

  if (!$scope.filterService.hasFilter('account_reports') && $scope.authDataService.isNotStaff()) {
    $scope.filterService.setFilter('account_reports', AccountUserService.currentAccountUser.account);
    if ($scope.filterService.accounts.length > 1) {
      $scope.filterService.setFilter('filters', 'account_reports');
    }
  }

  $scope.filters_options = [
    { group: 'hierarchy',
      name: 'By Hierarchy',
      elements: [
        {
          id: 'account_reports',
          name: 'Account',
          label: null,
          inline: false,
          type: 'options',
          multiple: true,
          placeholder: 'All Accounts',
          condition: $scope.filterService.accounts.length > 1 && $scope.authDataService.isNotStaff(),
          options: $scope.filterService.accounts,
          conflicts: ['property_reports', 'portfolio_reports', 'group_reports', 'managed_by_reports']
        }
      ]
    },
    {
      id: 'user_role_search',
      name: 'Role Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Name contains',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];

};

app.controller('UserRolesListFilters', [
  '$scope',
  '$controller',
  'AccountUserService',
  UserRolesListFilters
]);
